import React, { useEffect, useState } from "react";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import { StaffList } from "../../../api/Staff";
import { courseList } from "../../../api/Courses";
import { useLocation, useNavigate } from "react-router-dom";
import { batchDetails, batchUpdate } from "../../../api/Batch";
import { feeTypes } from "../../config/Data";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function BatchUpdate() {
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [data, setData] = useState({});

  useEffect(() => {
    setSessions(JSON.parse(localStorage.getItem("sessions") ?? "[]"));
  }, []);

  const getBatchInfo = async () => {
    setLoading(true);
    try {
      const response = await batchDetails(id);
      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await batchUpdate(formData);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
        navigate("/batches");
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    setLoading(true);
    try {
      const response = await StaffList();
      if (response.data.status) {
        setStaffs(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
    getStaffs();
  }, []);

  useEffect(() => {
    getBatchInfo();
  }, [id]);

  const addFeeRow = () => {
    const feeDetails = data?.fee_details || [];

    if (feeDetails.length >= feeTypes.length) {
      SweetAlertShow(
        "info",
        "Warning",
        "All fee types have already been added."
      );
      return;
    }
    setData({
      ...data,
      fee_details: [
        ...(data?.fee_details || []),
        {
          batch_fee_id: "",
          fee_type: "",
          amount: "",
          apply_on: "All Student",
        },
      ],
    });
  };

  const removeFeeRow = (index) => {
    setData({
      ...data,
      fee_details: data.fee_details.filter((_, i) => i !== index),
    });
  };

  const updateFeeRow = (index, field, value) => {
    const temp = [...data.fee_details];

    temp[index] = {
      ...temp[index],
      [field]: value,
    };

    setData({
      ...data,
      fee_details: temp,
    });
  };
  const isFeeTypeSelected = (feeType, currentIndex) => {
    return (data?.fee_details || []).some(
      (fee, index) =>
        index !== currentIndex &&
        fee?.fee_type === feeType
    );
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleFormSubmit}>
                          <input
                            type="hidden"
                            name="id"
                            id="id"
                            value={data?.id}
                          />
                          <div className="row g-0">
                            <div className="col-12">
                              <h4 className="text-primary m-0">Batch Update</h4>
                              <hr className="my-2" />
                            </div>

                            <div className="col-12">
                              <h6 className="mb-2">Basic Details</h6>
                              <div className="row g-2">
                                <div className="col-sm-2">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="session_id"
                                      value={data?.session_id}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          session_id: e.target.value,
                                        })
                                      }
                                    >
                                      {sessions?.map((session) => (
                                        <option
                                          key={session?.id}
                                          value={session?.id}
                                        >
                                          {session?.session} :{" "}
                                          {session?.status === "1"
                                            ? "Active"
                                            : " Inactive"}
                                        </option>
                                      ))}
                                    </select>
                                    <label htmlFor="course">
                                      Select session
                                    </label>
                                  </div>
                                </div>

                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      id="course_id"
                                      name="course_id"
                                      required
                                      value={data?.course_id}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          course_id: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" selected disabled>
                                        Select Course
                                      </option>
                                      {courses.map((course) => (
                                        <option
                                          key={course.id}
                                          value={course.id}
                                        >
                                          {course.title}
                                        </option>
                                      ))}
                                    </select>
                                    <label htmlFor="course">
                                      Select Course
                                    </label>
                                  </div>
                                </div>

                                <div className="col-sm-4">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control input-capitalize"
                                      id="title"
                                      placeholder="Enter Batch Name"
                                      name="title"
                                      required
                                      value={data?.title}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          title: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="title">Batch Title</label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="class_teacher"
                                      value={data?.class_teacher}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          class_teacher: e.target.value,
                                        })
                                      }
                                    >
                                      <option value="" selected disabled>
                                        Select Staff
                                      </option>
                                      {staffs?.map((staff) => (
                                        <option
                                          key={staff?.id}
                                          value={staff?.id}
                                        >
                                          {staff?.name}
                                        </option>
                                      ))}
                                    </select>

                                    <label htmlFor="teacher">
                                      Batch/Class Teacher
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <hr className="my-2" />
                            </div>

                            <div className="col-12">
                              <div className="d-flex align-items-center justify-content-between">
                                <h6 className="mb-2">Batch Fee Structure</h6>
                                <button
                                  type="button"
                                  className="btn btn-success px-2 py-1"
                                  onClick={addFeeRow}
                                >
                                  +
                                </button>
                              </div>
                              {data?.fee_details?.map((fee, index) => (
                                <div
                                  className="row g-2 mb-2 align-items-center"
                                  key={index}
                                >
                                  <input
                                    type="hidden"
                                    name={`batch_fee_id[${index}]`}
                                    id="batch_fee_id"
                                    value={fee?.id ?? null}
                                  />
                                  <div className="col-md-4">
                                    <div className="form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        value={fee.fee_type}
                                        name={`fee_type[${index}]`}
                                        required
                                        onChange={(e) =>
                                          updateFeeRow(
                                            index,
                                            "fee_type",
                                            e.target.value,
                                          )
                                        }
                                      >
                                        <option value="" selected disabled>
                                          Select Fee Type
                                        </option>
                                        {feeTypes.map((type) => (
                                          <option
                                            key={type}
                                            value={type}
                                            disabled={isFeeTypeSelected(type, index)}
                                          >
                                            {type}
                                          </option>
                                        ))}
                                      </select>
                                      <label htmlFor="">Select Fee Type</label>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-floating form-floating-outline">
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Amount"
                                        name={`amount[${index}]`}
                                        value={fee.amount}
                                        required
                                        min="0"
                                        onChange={(e) =>
                                          updateFeeRow(
                                            index,
                                            "amount",
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <label htmlFor="">Amount</label>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="d-flex gap-2 align-items-center">
                                      <div className="form-floating form-floating-outline w-100">
                                        <select
                                          className="form-select"
                                          value={fee.apply_on}
                                          name={`apply_on[${index}]`}
                                          required
                                          onChange={(e) =>
                                            updateFeeRow(
                                              index,
                                              "apply_on",
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <option value="All Student">
                                            All Students
                                          </option>

                                          <option value="New Student">
                                            Only New Students
                                          </option>
                                          <option value="Selected Student">
                                            Selected Students
                                          </option>
                                        </select>
                                        <label htmlFor=""> Apply For</label>
                                      </div>
                                      <button
                                        type="button"
                                        className="btn btn-danger  px-2 py-1"
                                        onClick={() => removeFeeRow(index)}
                                      >
                                        <i className="ri-delete-bin-line"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              <hr className="my-2" />
                            </div>
                            <div className="col-12">
                              <h6 className="mb-2">Batch Timing</h6>
                              <div className="row g-2">
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="duration"
                                      placeholder="Duration in Months"
                                      name="duration"
                                      required
                                      min={0}
                                      value={data?.duration}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          duration: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="duration">
                                      Duration (Months)
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="date"
                                      className="form-control"
                                      id="starting_date"
                                      name="starting_date"
                                      required
                                      value={data?.starting_date}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          starting_date: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="starting_date">
                                      Starting Date
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="time"
                                      className="form-control"
                                      id="start_time"
                                      name="start_time"
                                      required
                                      value={data?.start_time}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          start_time: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="start_time">
                                      Start Timing
                                    </label>
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="time"
                                      className="form-control"
                                      id="end_time"
                                      name="end_time"
                                      required
                                      value={data?.end_time}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          end_time: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="end_time">End Time</label>
                                  </div>
                                </div>
                              </div>
                              <hr className="my-2" />
                            </div>
                            <div className="col-12">
                              <h6 className="mb-2">Other Details</h6>
                              <div className="row g-2">
                                <div className="col-sm-3">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="student_limit"
                                      placeholder="student_limit"
                                      name="student_limit"
                                      min="0"
                                      value={data?.student_limit}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          student_limit: e.target.value,
                                        })
                                      }
                                    />
                                    <label htmlFor="student_limit">
                                      Student Limit
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>

                            <div className="col-sm-12">
                              <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Submit"
                                )}
                                {loading ? " Submitting..." : ""}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
